import { Product } from "../../../types/types";

export const generateBreadcrumbs = (product: Product) => {
  const result = product.browsePageHierarchy.map((browsePage) => {
    return {
      clickable: 1,
      value: browsePage.name?.toLowerCase(),
    };
  });

  result.shift();

  return result;
};
